import PropTypes from "prop-types";
import React from "react";

import SPACING from "shared/config/spacing";
import { StyledVStack } from "./VStack.styles";

const VStack = React.forwardRef(({ spacing, align, ...props }, ref) => {
    return (
        <StyledVStack $spacing={spacing} $align={align} {...props} ref={ref} />
    );
});

VStack.defaultProps = {
    spacing: SPACING.One,
};

VStack.propTypes = {
    spacing: PropTypes.oneOf(Object.keys(SPACING)),
    align: PropTypes.string,
};

export default VStack;
